const customStyles = {
  control: base => ({
    ...base,
    backgroundColor: '#f0f3f7',
    border: '1px solid #9EA4AC !important',
    boxShadow: 'none',
    cursor: 'pointer',
    transition: 'all .4s',
    minHeight: '25px',
    '&:hover': {
      backgroundColor: '#b3f0f0',
    },
  }),
  dropdownIndicator: base => ({
    ...base,
    color: '#000',
    padding: '0 2px',
  }),
  option: (base) => ({
    ...base,
    backgroundColor: null,
    color: '#353a40',
    cursor: 'pointer',
    fontSize: '0.7rem',
    transition: 'all .4s',
    ':hover': {
      backgroundColor: '#f0f3f7',
    },
    ':active': {
      ...base[':active'],
      backgroundColor: '#b3f0f0',
    },
  }),
  singleValue: base => ({
    ...base,
    color: '#000',
    fontSize: '0.7rem',
  }),
}

export default customStyles
